import { Box, Button, Typography, styled } from '@mui/material';

export const StyledContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '0px !important',
});

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.warning.main,
  marginLeft: theme.spacing(0.5),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[50],
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0.15,
  textDecoration: 'underline',
  marginLeft: 'auto',
  '&:hover': {
    cursor: 'pointer',
  },
}));
